
import { createSlice } from "@reduxjs/toolkit";
import { initialLayerState } from "../config/config.layers";
export const layerSlice = createSlice({
  name: "layers",
  initialState: initialLayerState,
  reducers: {
    toggleLayer(state, action) {
      const { id } = action.payload;
      state[id].showLayer = !state[id].showLayer;
    },
    updatePointCount(state, action) {
      const { id, count } = action.payload;
      state[id].pointCount = count;
    },
    toggleLayerControl(state, action) {
      const { id } = action.payload;
      state[id].showLayerControl = !state[id].showLayerControl;
    },
    showLayerControl(state, action) {
      const { id } = action.payload;
      state[id].showLayerControl = true;
    },
    changeColorValue(state, action) {
      const { id, colorValue } = action.payload;
      state[id].colorValue = colorValue;
    },
    clearFilters(state, action) {
      const { id } = action.payload;
      state[id].activeFilters = {};
    },
    addFilter(state, action) {
      const { id, filterProperty, filterValues } = action.payload;
      // state[id].activeFilters[filterProperty] = filterValue;
      state[id].activeFilters[filterProperty] = filterValues;
    },
    removeFilter(state, action) {
      const { id, key } = action.payload;
      const newActiveFilters = JSON.parse(
        JSON.stringify(state[id].activeFilters)
      );
      delete newActiveFilters[key];
      state[id].activeFilters = newActiveFilters;
    },
    removeFilterValue(state, action) {
      const { id, filter_id, category } = action.payload;
      let newActiveFilter = JSON.parse(
        JSON.stringify(state[id].activeFilters[filter_id])
      );
      const removeIndex = newActiveFilter.indexOf(category);
      if (removeIndex > -1) {
        newActiveFilter.splice(removeIndex, 1);
      }
      // remove filter entirely if no filter categories remain
      if (newActiveFilter.length === 0) {
        const newActiveFilters = JSON.parse(
          JSON.stringify(state[id].activeFilters)
        );
        delete newActiveFilters[filter_id];
        state[id].activeFilters = newActiveFilters;
      } else {
        state[id].activeFilters[filter_id] = newActiveFilter;
      }
    },
    setFilters(state, action) {
      const { id, newActiveFilters } = action.payload;
      state[id].activeFilters = newActiveFilters;
    },
    updateColorMap(state, action) {
      const { layerId, propertyId, colorMap } = action.payload;
      // state[id].colorMap = generateColorMap(state[id].data, state[id].colorValue);
      // const colorValue = state[layerId].colorValue;
      // state[layerId].colorOptions[colorValue].colorMap = colorMap;
      const propertyIndex = state[layerId].properties.findIndex(
        (p) => p.id === propertyId
      );
      state[layerId].properties[propertyIndex].colorMap = colorMap;
    },
    setActiveLayers(state, action) {
      const { activeLayers } = action.payload;
      Object.keys(state).forEach((id) => {
        if (activeLayers.includes(id)) {
          state[id].showLayer = true;
        } else {
          state[id].showLayer = false;
        }
      });
    },
    togglePropertyGroupVisibility(state, action) {
      const { layerId, groupId } = action.payload;
      const isVisible = state[layerId].propertyGroups[groupId].isVisible;
      const groups = state[layerId].propertyGroups;

      Object.keys(groups).forEach((group) => {
        groups[group].isVisible = false;
      });

      if (isVisible === undefined) {
        groups[groupId].isVisible = true;
      } else {
        groups[groupId].isVisible = !isVisible;
      }

      state[layerId].propertyGroups = groups;
    },
    toggleShowNoData(state, action) {
      const { layerId, propertyId } = action.payload;

      const propertyIndex = state[layerId].properties.findIndex(
        (p) => p.id === propertyId
      );

      const showNoData =
        state[layerId].properties[propertyIndex].showNoData;

      if (
        state[layerId].properties[propertyIndex].showNoData === undefined
      ) {
        state[layerId].properties[propertyIndex].showNoData = true;
      } else {
        state[layerId].properties[propertyIndex].showNoData = !showNoData;
      }
    },
  },
});